import { http } from '../utils/http';
import { Response } from '../types/resp';
import { ExternalPrefixResult, ProfileResult } from '../types/external';

export const external = {
	checkUse: async (payload: any) => {
		return http.post<Response<any>>('/check-use', payload);
	},

	checkPhone: async (payload: any) => {
		return http.post<Response<any>>('/check-phone', payload);
	},

	captcha: async (payload: any) => {
		return http.post<Response<any>>('/captcha', payload);
	},

	otp: async (payload: any) => {
		return http.post<Response<any>>('/otp', payload);
	},

	checkOtp: async (payload: any) => {
		return http.post<Response<any>>('/check-otp', payload);
	},

	register: async (payload: any) => {
		return http.post<Response<any>>('/register', payload);
	},

	login: async (payload: any) => {
		return http.post<Response<any>>('/login', payload);
	},

	logout: async (payload: any) => {
		return http.post<Response<any>>('/logout', payload);
	},

	profile: async (payload: any) => {
		return http.post<Response<ProfileResult>>('/profile', payload);
	},

	prefix: async (payload: any) => {
		return http.post<Response<ExternalPrefixResult>>('/prefix', payload);
	},

	bankList: async (payload: any) => {
		return http.post<Response<any>>('/bank-list', payload);
	},

	updateBank: async (payload: any) => {
		return http.post<Response<any>>('/update-bank', payload);
	},

	updateInformation: async (payload: any) => {
		return http.post<Response<any>>('/customer/update-information', payload);
	},

	updatePass: async (payload: any) => {
		return http.post<Response<any>>('/update-pass', payload);
	},

	forgotPass: async (payload: any) => {
		return http.post<Response<any>>('/forgot-pass', payload);
	},

	recommendList: async (payload: any) => {
		return http.post<Response<any>>('/recommend-list', payload);
	},

	getPeer2PayInfo: async () => {
		return http.get<Response<any>>('/getPeer2PayInfo');
	},

	tournament: async () => {
		return http.get<Response<any>>('/tournament');
	}
};
